import {useSelector} from 'react-redux';

export default () =>
	useSelector(({activityLog}) => ({column: activityLog.column, direction: activityLog.direction}));
